import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { EditIcon } from "../../../ui/icons/edit"
import { optionsFormatter, formatterDate, statoRichiestaComplianceRequest } from "../../../utils"
import { useEffect, useState } from "react"
import { ComplianceRequestDelete, GetAllComplianceRequests, resetGetAllStatus, setEditCustomerOtherOdcDefault, setEditRequestDescription, setEditRequestNote, setEditRequestProduct, setEditRequestProtocolId, setEditRequestSender, setEditRequestType, setRequestId, setRequestStateDetails } from "./slice"
import { SpinnerComponent } from "../../../lib/spinner"
import { ComplianceResponseDTO } from "./dataService/dto"
import { TrashIcon } from "../../../ui/icons/trash"
import { Alert } from "../../../ui/organisms/alert"
import Button from "../../../ui/molecules/button"
import { Banner } from "../../../ui/organisms/banner"

export function CustomerList() {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const complianceRequestState = useAppSelector(state => state.complianceRequest)
    const [showAlert, setShowAlert] = useState<boolean>(false)
    const sessionState = useAppSelector(state => state.session)
    const [complianceRequestToDelete, setComplianceRequestToDelete] = useState<string | null>(null)
    useEffect(() => {
        dispatch(GetAllComplianceRequests({ itemsPerPage: 10, page: 0, customerDataId: sessionState.selected.customerId!, order: true }))
    }, [])

    useEffect(() => {
        if (complianceRequestState.getAllComplianceRequestsStatus === 'successfully') {
            dispatch(resetGetAllStatus())
        }
    }, [complianceRequestState.getAllComplianceRequestsStatus])

    useEffect(() => {
        if (complianceRequestState.ComplianceRequestDeleteStatus === 'successfully') {
            dispatch(GetAllComplianceRequests({ itemsPerPage: 10, page: 0, customerDataId: sessionState.selected.customerId!, order: true }))
        }
    }, [complianceRequestState.ComplianceRequestDeleteStatus])

    if (complianceRequestState.getAllComplianceRequestsStatus === 'loading') {
        return (
            <SpinnerComponent size={'large'} />
        )
    }

    const requests = complianceRequestState.allComplianceRequestsResponse?.data ?? []

    const onEditHandle = (request: ComplianceResponseDTO) => {
        dispatch(setRequestStateDetails(request.complianceRequestStates))
        if (request.otherOdcCustomer && request.otherOdcCustomer.length > 0) {
            dispatch(setEditCustomerOtherOdcDefault(request.otherOdcCustomer))
        }
        dispatch(setRequestId(request.id))
        dispatch(setEditRequestDescription(request.description))
        dispatch(setEditRequestNote(request.note))
        dispatch(setEditRequestProtocolId(request.requestProtocolId))
        dispatch(setEditRequestSender(request.sender))
        dispatch(setEditRequestType(request.requestType))
        dispatch(setEditRequestProduct(request.product))

        navigate('/editComplianceRequest')
    }
    if (sessionState.selected.customerId) {
        return (
            <div className="p-6">
                <div className="w-full overflow-x-auto rounded-xl border border-neutral-200 shadow-sm">
                    <table id="users-table" className="w-full border-collapse text-sm">
                        <thead>
                            <tr className="bg-brandPrimary-600 text-white uppercase text-xs tracking-wide h-[52px]">
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tl-xl">Data Richiesta</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Mittente</th>
                                <th className="px-3 py-3 text-left font-semibold">Cliente Altro OdC</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Protocollo Entrata</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Stato</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Funzionario</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Data</th>
                                <th className="px-3 py-3 text-center font-semibold whitespace-nowrap rounded-tr-xl w-[64px]"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {requests.length === 0 ? (
                                <tr>
                                    <td colSpan={8} className="px-3 py-3 text-center text-neutral-500 bg-white">
                                        Nessun cliente trovato
                                    </td>
                                </tr>
                            ) : (
                                requests.map((request, index) =>
                                    <tr
                                        key={request.id ?? index}
                                        className={`border-b border-neutral-200 transition-colors duration-150 hover:bg-brandPrimary-50 ${index % 2 === 0 ? 'bg-white' : 'bg-neutral-50'}`}
                                    >
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap text-xs">{formatterDate(request.date)}</td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap font-medium">{request.sender || <span className="text-neutral-400">-</span>}</td>
                                        <td className="px-3 py-2 text-neutral-700 min-w-[240px]">
                                            {
                                                request.otherOdcCustomer?.length
                                                    ? request.otherOdcCustomer.map((customerOtherOdc) => (
                                                        <p
                                                            key={`${request.id}-${customerOtherOdc.clientCode}-${customerOtherOdc.cuaa}`}
                                                            className="text-xs leading-5"
                                                        >
                                                            {customerOtherOdc.companyName} - {customerOtherOdc.cuaa} - {customerOtherOdc.clientCode}
                                                        </p>
                                                    ))
                                                    : <span className="text-neutral-400">-</span>
                                            }
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap text-xs">{request.requestProtocolInfo || <span className="text-neutral-400">-</span>}</td>
                                        <td className="px-3 py-2 text-neutral-700 min-w-[140px]">
                                            {
                                                request.complianceRequestStates?.length
                                                    ? request.complianceRequestStates.map((state, stateIndex) => (
                                                        <p key={`${request.id}-${state.state}-${stateIndex}`} className="text-xs leading-5">
                                                            {optionsFormatter(state.state, statoRichiestaComplianceRequest)}
                                                        </p>
                                                    ))
                                                    : <span className="text-neutral-400">-</span>
                                            }
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap text-xs">{request.officerInfo || <span className="text-neutral-400">-</span>}</td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap text-xs">{formatterDate(request.date)}</td>
                                        <td className="px-3 py-2">
                                            <div className="flex items-center justify-center gap-2">
                                                <button
                                                    className="p-1 rounded hover:bg-neutral-100 transition-colors"
                                                    onClick={() => onEditHandle(request)}
                                                >
                                                    <EditIcon color="orange" size={20} />
                                                </button>
                                                <button
                                                    className="p-1 rounded hover:bg-neutral-100 transition-colors"
                                                    onClick={() => {
                                                        if (request.id) {
                                                            setComplianceRequestToDelete(request.id)
                                                            setShowAlert(true)
                                                        }
                                                    }}
                                                >
                                                    <TrashIcon color="orange" size={20} />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                )
                            )}
                        </tbody>
                    </table>
                </div>

                {
                    (showAlert && complianceRequestToDelete) && (
                        <Alert title="Conferma operazione" close={() => setShowAlert(false)}>
                            <div className="flex flex-col justify-center">
                                <div className="pb-3">
                                    <div>
                                        Sei sicuro di voler eliminare questa richiesta?
                                    </div>
                                </div>
                                <div className="mt-6 flex items-center justify-center">
                                    <Button
                                        variant="outline"
                                        color="dimgrey"
                                        iconPosition="off"
                                        label="Annulla"
                                        size="md"
                                        onClick={() => setShowAlert(false)}
                                    />
                                    <div className="pl-8">
                                        <Button
                                            variant="solid"
                                            color="orange"
                                            iconPosition="off"
                                            label="Elimina"
                                            size="md"
                                            onClick={() => {
                                                dispatch(ComplianceRequestDelete(complianceRequestToDelete))
                                                setShowAlert(false)
                                            }}
                                        />
                                    </div>
                                </div>

                            </div>
                        </Alert>
                    )
                }
            </div>
        )
    }

    return (
        <div className="p-6">
            <Banner
                type="error"
                visible={!sessionState.selected.customerId}
                label={"Devi prima selezionare un cliente per accedere all'elenco"}
                closeAction={function (): void {
                    alert("Devi prima selezionare un cliente per accedere all'elenco")
                }}
            />
        </div>
    )
}